function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { Flex } from "sprout-ui-primitives";
import { Image } from "sprout-ui-dom/dist/Image";
import imageCache from "sprout-lib/dist/image-cache";
import { ItemType } from "sprout-graphql";
const StyledImage = styled(Image)`
  object-fit: cover;
  object-position: center;

  width: inherit;
  height: inherit;
`;
const ItemImage = (props)=>{
    const { size , children , src , alt , type  } = props, rest = _objectWithoutProperties(props, [
        "size",
        "children",
        "src",
        "alt",
        "type"
    ]);
    return /*#__PURE__*/ _jsxs(Flex, _objectSpread({
        alignItems: "center",
        justifyContent: "center",
        borderRadius: type === ItemType.Post ? "12px" : "3px",
        bg: "grey.200",
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "black.4",
        flex: "none",
        width: size,
        height: size
    }, rest, {
        children: [
            children,
            src && /*#__PURE__*/ _jsx(StyledImage, {
                src: imageCache(src, {
                    w: size * 4
                }),
                alt: alt
            })
        ]
    }));
};
export default ItemImage;
